/* eslint-disable @typescript-eslint/ban-types */
import { NgModule, isDevMode,} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { AppService } from './api.service';
import { SharedModule } from './shared/shared.module';


import { HTTP_INTERCEPTORS, HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from './auth.interceptor';
import { ServiceWorkerModule } from '@angular/service-worker';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';


// import { AssetErrorInterceptor } from './interceptors/asset-error.interceptor';
import { CoreModule } from './core/core.module';

import { PopupContainerModule } from './global/popup-container/popup-container.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';




@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserAnimationsModule,
     // Angular modules
     BrowserModule.withServerTransition({ appId: 'serverApp' }),
  
     HttpClientJsonpModule,
     HttpClientModule,

    // App modules
    CoreModule,
    SharedModule,


     // Third-party
     FontAwesomeModule,

    AppRoutingModule,
    // NgbModule,
    
   
   // Infrastructure
     ServiceWorkerModule.register('ngsw-worker.js', {
       enabled: !isDevMode(),
       registrationStrategy: 'registerWhenStable:30000'
     }),
     PopupContainerModule
    // Feature modules
    // CashbackPopupModule,
    // ConnectPopupModule,
    // CompareOfferPopupModule,
    // SharePopupModule
],
  providers: [
  

    AppService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
